module.exports = __webpack_public_path__ + "img/planningS.4698bc4c.png";